import { useEffect, useRef, useState } from "react";

import lauraImg from "./images/weddings/header_00_05.jpg";
import gomezImg from "./images/header/header_00_02.jpg";
import emilyJonasImg from "./images/headshots/headshot_02.jpg";
import moniqueImg from "./images/weddings/weddings_0033.jpg";

const testimonials = [
  {
    name: "Rebecca Kilborne",
    location: "Rural Canada",
    quote:
      "Alejandro was the perfect photographer for our wedding, capturing the fun and joy beautifully and unobtrusively. We love our wedding photos.",
    shoot: "Wedding Photography",
    image: lauraImg,
    orientation: "landscape",
  },
  {
    name: "The Gomez Family",
    location: "Santa Monica, California",
    quote:
      "No ask was too big. From planning outfits to choosing locations, Alejandro guided us through everything. Our family photos look timeless, not staged.",
    shoot: "Family Session",
    image: gomezImg,
    orientation: "portrait",
  },
  {
    name: "Professor of History Lily Hindy",
    location: "Culver City, Los Angeles",
    quote:
      "Highly recommend Alejandro for professional headshots. He is a master of lighting and takes great care to capture the look you want. I sent him a few references and we talked over the look I was going for, and he made it happen. I am very happy with the product.",
    shoot: "Business Headshot",
    image: emilyJonasImg,
    orientation: "landscape",
  },
  {
    name: "Masha Brenner",
    location: "New York City, New York",
    quote:
      "Not only did he get some amazing candid shots that made the celebration come alive, but also he was very innovative with the way he arranged the posed portraits, making them feel fresh and original in a way few wedding photographers can.",
    shoot: "Wedding Photography",
    image: moniqueImg,
    orientation: "portrait",
  },
];

function CustomerSays() {
  const [active, setActive] = useState(0);
  const [isStoryOpen, setIsStoryOpen] = useState(false);

  const dialogRef = useRef(null);
  const triggerRef = useRef(null);

  const current = testimonials[active];
  const isPortrait = current.orientation === "portrait";

  const closeStory = () => {
    setIsStoryOpen(false);

    window.setTimeout(() => {
      triggerRef.current?.focus();
    }, 0);
  };

  const openStory = () => {
    setIsStoryOpen(true);
  };

  const selectStory = (index) => {
    setActive(index);
  };

  useEffect(() => {
    if (!isStoryOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeStory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    window.setTimeout(() => {
      dialogRef.current?.focus();
    }, 0);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isStoryOpen]);

  return (
    <section
      className="w-full bg-[#f4f3ef] py-16 sm:py-20 lg:py-28"
      aria-labelledby="client-stories-title"
    >
      <div className="mx-auto w-full max-w-[1600px] px-5 sm:px-8 lg:px-12">
        <header className="mb-10 flex items-end justify-between gap-6 sm:mb-14">
          <div>
            <p className="mb-3 text-[10px] font-medium uppercase tracking-[0.25em] text-stone-500">
              Kind words
            </p>

            <h2
              id="client-stories-title"
              className="font-serif text-5xl leading-none text-stone-900 sm:text-6xl lg:text-7xl"
            >
              Client stories
            </h2>
          </div>

          <p className="hidden text-[10px] font-medium uppercase tracking-[0.2em] text-stone-500 sm:block">
            {String(active + 1).padStart(2, "0")} —{" "}
            {String(testimonials.length).padStart(2, "0")}
          </p>
        </header>

        <div className="grid gap-8 lg:grid-cols-[minmax(0,1.45fr)_minmax(290px,0.55fr)] lg:gap-12">
          <button
            ref={triggerRef}
            type="button"
            onClick={openStory}
            aria-label={`Read the full story from ${current.name}`}
            className="group relative flex min-h-[56svh] w-full items-center justify-center overflow-hidden bg-white text-left outline-none focus-visible:ring-2 focus-visible:ring-stone-900 focus-visible:ring-offset-4 focus-visible:ring-offset-[#f4f3ef] sm:min-h-[64svh] lg:min-h-[72svh]"
          >
            <img
              src={current.image}
              alt={`${current.shoot} for ${current.name}`}
              className={`block max-h-[72svh] max-w-full select-none object-contain ${
                isPortrait ? "h-[72svh] w-auto" : "h-auto w-full"
              }`}
              loading="lazy"
              decoding="async"
              draggable="false"
            />

            <span className="absolute bottom-4 left-4 bg-white/90 px-3 py-2 text-[9px] font-medium uppercase tracking-[0.2em] text-stone-900 backdrop-blur-sm transition-colors group-hover:bg-stone-900 group-hover:text-white sm:bottom-5 sm:left-5">
              Read story
            </span>
          </button>

          <div className="flex flex-col justify-between border-t border-stone-300 pt-6 lg:border-l lg:border-t-0 lg:pl-10 lg:pt-0">
            <div>
              <p className="text-[10px] font-medium uppercase tracking-[0.22em] text-stone-500">
                {current.shoot}
              </p>

              <h3 className="mt-4 font-serif text-4xl leading-[0.95] text-stone-900 sm:text-5xl lg:text-6xl">
                {current.name}
              </h3>

              <p className="mt-4 text-[10px] font-medium uppercase tracking-[0.18em] text-stone-500">
                {current.location}
              </p>

              <blockquote className="mt-10 border-l border-stone-400 pl-5">
                <p className="font-serif text-2xl leading-snug text-stone-800 sm:text-3xl">
                  “{current.quote}”
                </p>
              </blockquote>

              <button
                type="button"
                onClick={openStory}
                className="mt-8 inline-flex items-center gap-3 border-b border-stone-900 pb-2 text-[10px] font-medium uppercase tracking-[0.2em] text-stone-900 transition-opacity hover:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-stone-900 focus-visible:ring-offset-4 focus-visible:ring-offset-[#f4f3ef]"
              >
                Read full story
                <span aria-hidden="true" className="text-base leading-none">
                  ↗
                </span>
              </button>
            </div>

            <div
              className="mt-12 flex gap-3 overflow-x-auto pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
              aria-label="Choose a client story"
            >
              {testimonials.map((testimonial, index) => {
                const isActive = index === active;

                return (
                  <button
                    key={testimonial.name}
                    type="button"
                    onClick={() => selectStory(index)}
                    aria-label={`Show testimonial from ${testimonial.name}`}
                    aria-pressed={isActive}
                    className={`relative h-16 w-12 shrink-0 overflow-hidden bg-white outline-none transition-opacity focus-visible:ring-2 focus-visible:ring-stone-900 focus-visible:ring-offset-4 focus-visible:ring-offset-[#f4f3ef] sm:h-20 sm:w-16 ${
                      isActive
                        ? "opacity-100 ring-1 ring-stone-900 ring-offset-2 ring-offset-[#f4f3ef]"
                        : "opacity-40 hover:opacity-75"
                    }`}
                  >
                    <img
                      src={testimonial.image}
                      alt=""
                      className="h-full w-full select-none object-cover"
                      loading="lazy"
                      decoding="async"
                      draggable="false"
                    />
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {isStoryOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-stone-950/60 p-5 backdrop-blur-sm sm:p-8"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              closeStory();
            }
          }}
        >
          <article
            ref={dialogRef}
            role="dialog"
            aria-modal="true"
            aria-labelledby="story-dialog-title"
            tabIndex={-1}
            className="relative max-h-[90svh] w-full max-w-3xl overflow-y-auto bg-[#f8f7f3] px-7 py-14 shadow-2xl outline-none sm:px-12 sm:py-16 lg:px-16 lg:py-20"
          >
            <button
              type="button"
              onClick={closeStory}
              aria-label="Close client story"
              className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full border border-stone-300 text-xl text-stone-900 transition-colors hover:bg-stone-900 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-stone-900 sm:right-7 sm:top-7"
            >
              ×
            </button>

            <p className="text-[10px] font-medium uppercase tracking-[0.22em] text-stone-500">
              Client story · {current.shoot}
            </p>

            <h3
              id="story-dialog-title"
              className="mt-6 font-serif text-4xl leading-none text-stone-900 sm:text-5xl"
            >
              {current.name}
            </h3>

            <p className="mt-3 text-[10px] font-medium uppercase tracking-[0.18em] text-stone-500">
              {current.location}
            </p>

            <blockquote className="mt-12">
              <p className="font-serif text-3xl leading-[1.18] text-stone-800 sm:text-4xl lg:text-5xl">
                “{current.quote}”
              </p>
            </blockquote>
          </article>
        </div>
      )}
    </section>
  );
}

export default CustomerSays;